import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, TemplateRef, input, output } from '@angular/core'

import { TreeNode } from 'primeng/api'
import { BreadcrumbModule } from 'primeng/breadcrumb'
import { TooltipModule } from 'primeng/tooltip'
import { TreeTableModule } from 'primeng/treetable'

import { FlxEmptyInfoboxComponent } from '../empty-infobox/empty-infobox.component'

export type ExpandableTableColumn = {
  header: string
  field: string
  class?: string
  template?: TemplateRef<any>
  width?: number
}

@Component({
  selector: 'flx-expandable-table',
  imports: [
    CommonModule,
    TreeTableModule,
    FlxEmptyInfoboxComponent,
    BreadcrumbModule,
    TooltipModule,
  ],
  templateUrl: './expandable-table.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './expandable-table.component.scss',
})
export class ExpandableTableComponent {
  value = input.required<TreeNode[]>()
  columns = input.required<ExpandableTableColumn[]>()
  expandableFields = input<string[]>()
  height = input<string>('flex')
  expandRow = output<TreeNode>()
  collapseRow = output<TreeNode>()
  emptyMessage = input<string>('No entries found')
  frozenColumns = input<ExpandableTableColumn[]>([])
  frozenColumnsWidth = input<string>('0px')
}
